module.exports = __webpack_public_path__ + "media/images/logo_big-18237f73dde879cb5ea23a943e21ac0b.jpg";